import * as React from 'react';

import Icon from 'components/Icon';

type IconMap = { [key: string]: React.ReactElement<typeof Icon> };

export function getIconCellGenerator<T>(fieldName: keyof T, iconMap: IconMap) {
  return (data: T) => {
    const iconName = (data[fieldName] as unknown) as string;
    const icon = iconMap[iconName];
    return icon ? React.cloneElement(icon) : <span data-test="empty-icon-cell" />;
  };
}
